const matchMedia = globalThis.matchMedia;
export { matchMedia };
//# sourceMappingURL=matchMedia.mjs.map
